<template>
  <div
    class="branding-logo"
    :class="{ 'is-filled': filled }"
    data-unit-test="branding-logo"
  >
    <img
      :src="src"
      :alt="alt"
    >
  </div>
</template>

<script>
export default {
  name: 'branding-logo',
  inject: ['constants', 'config'],
  props: {
    brandingType: {
      type: String,
      required: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    src () {
      switch (this.brandingType) {
        case 'QuotezoneAffiliate':
          return this.constants.PARTNERS.CompareNI.includes(this.config.partner)
            ? require('@/assets/images/logos/compareNI.svg')
            : this.constants.DEFAULT_LOGO;
        case 'Seopa':
          return require('@/assets/images/logos/seopa-provided.svg');
        case 'Quotezone':
        default:
          return require('@/assets/images/logos/quotezone-provided.svg');
      }
    },
    alt () {
      return `${this.brandingType} logo`;
    },
  },
};
</script>

<style lang="scss" scoped>
.branding-logo {
  text-align: center;
  overflow: hidden;
  width: auto;
  height: 40px;
  margin-bottom: 10px;

  &.is-filled {
    padding: 6px;
    border-radius: 6px;
    background-color: #fff;
  }

  & > img {
    height: 100%;
    width: auto;
    max-width: 100%;
  }
}
</style>
